import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';

/**
 * Colunas da tabela de candidatos (visão RH)
 * Mantido o nome da função/export.
 */
const formatCPF = (cpf) => {
  if (!cpf) return '';
  const digits = String(cpf).replace(/\D/g, '').padStart(11, '0').slice(-11);
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

const formatPhone = (phone) => {
  if (!phone) return '';
  const d = String(phone).replace(/\D/g, '');
  // tenta formato +55 (47) 99999-8888
  if (d.length >= 12) {
    const cc = d.slice(0, 2);
    const dd = d.slice(2, 4);
    const nine = d.length === 13 ? d.slice(4, 9) : d.slice(4, 8);
    const rest = d.slice(4 + nine.length);
    return `+${cc} (${dd}) ${nine}-${rest}`;
  }
  if (d.length === 11) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  }
  if (d.length === 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return phone;
};

const formatDateBR = (raw) => {
  if (!raw) return '';
  const dt = new Date(raw);
  if (isNaN(dt)) return '';
  return dt.toLocaleDateString('pt-BR');
};

export const getPedidosColumns = (handleEditar, handleExcluir) => [
  {
  id: 'Visualizado',
  header: 'Visualizado',
  accessorKey: 'Visualizado',
  size: 120,
  enableSorting: true,
  cell: ({ row }) => {
    // pega o valor cru vindo da API
    const raw = row?.original?.Visualizado;
    const visto = Number(raw) > 0;
    console.log('Visualizado ->', row?.original?.Visualizado, typeof row?.original?.Visualizado);

    return visto ? (
      <span
        style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '0.8rem',
        }}
      >
        Visualizado
      </span>
    ) : (
      <span
        style={{
          backgroundColor: '#F44336',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '0.8rem',
        }}
      >
        Não visualizado
      </span>
    );
  },
},
  {
    id: 'NomeCompleto',
    header: 'Nome',
    accessorFn: (row) => [row?.Nome, row?.Sobrenome].filter(Boolean).join(' '),
    size: 220,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue() || ''} maxLength={40} />
  },
  {
    id: 'CPF',
    header: 'CPF',
    accessorKey: 'CPF',
    size: 140,
    enableSorting: true,
    cell: ({ getValue }) => formatCPF(getValue())
  },
  {
    id: 'Email',
    header: 'E-mail',
    accessorKey: 'Email',
    size: 240,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue() || ''} maxLength={40} />
  },
  {
    id: 'NumeroTelefone',
    header: 'Telefone',
    accessorKey: 'NumeroTelefone',
    size: 160,
    enableSorting: false,
    cell: ({ getValue }) => {
      const v = getValue();
      const formatted = formatPhone(v);
      return v ? (
        <Tooltip content={v}>
          <span>{formatted}</span>
        </Tooltip>
      ) : '';
    }
  },
  {
    id: 'Localizacao',
    header: 'Localização',
    accessorFn: (row) => {
      const cidade = row?.CidadeLocalizacao || '';
      const uf = row?.EstadoLocalizacao || '';
      return [cidade, uf].filter(Boolean).join(' / ');
    },
    size: 200,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue() || ''} maxLength={40} />
  },
  {
    id: 'Escolaridade',
    header: 'Escolaridade',
    accessorKey: 'Escolaridade',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => {
      const v = (getValue() || '').toString();
      if (!v) return '';
      return <TableBadge text={v} />;
    }
  },
  {
    id: 'TituloVaga',
    header: 'Titulo da Vaga',
    accessorKey: 'TituloVaga',
    size: 100,
    enableSorting: true,
    cell: ({ getValue }) => getValue() ?? ''
  },
  {
    id: 'DataCriado',
    header: 'Criado em',
    accessorKey: 'DataCriado',
    size: 140,
    enableSorting: true,
    cell: ({ getValue }) => formatDateBR(getValue())
  },
];